import { siteStats } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function StatsBanner() {
  return (
    <section className="py-12 bg-primary-500" aria-label="网站数据">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-background-50 mb-1">{siteStats.totalManhua}</p>
              <p className="text-background-50/70 text-xs">漫画作品</p>
            </div>
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-background-50 mb-1">{siteStats.totalChapters}</p>
              <p className="text-background-50/70 text-xs">章节总数</p>
            </div>
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-background-50 mb-1">{siteStats.dailyVisitors}</p>
              <p className="text-background-50/70 text-xs">日访问量</p>
            </div>
            <div className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-background-50 mb-1">{siteStats.registeredUsers}</p>
              <p className="text-background-50/70 text-xs">注册用户</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}